"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bcmTargetRegisterActions = require("../bcmTargetRegister/bcmTargetRegisterActions");
var _activationReviewNaturalDisasterActions = require("../document/activationReviewNaturalDisasterActions");
var _bcmKunrenActions = require("../kunren/bcmKunrenActions");
var _bcmPermissionSettingActions = require("../setting/bcmPermissionSettingActions");
var _bcmTargetSearchActions = require("../targetSearch/bcmTargetSearchActions");
const bcmReducers = {
  bcmKunren: _bcmKunrenActions.bcmKunrenReducer,
  bcmPermissionSetting: _bcmPermissionSettingActions.bcmPermissionSettingReducer,
  activationReviewNaturalDisaster: _activationReviewNaturalDisasterActions.activationReviewNaturalDisasterReducer,
  bcmTargetRegister: _bcmTargetRegisterActions.bcmTargetRegisterReducer,
  bcmTargetSearch: _bcmTargetSearchActions.bcmTargetSearchReducer
};
var _default = exports.default = bcmReducers;